import { isPastDate } from 'app/discounts/utils/discounts';
import moment from 'moment';
import React, { FC } from 'react';

interface DatesProps {
  value: any;
}

const Dates: FC<DatesProps> = ({ value }: { value: any }) => {
  const isPast = isPastDate(value);
  return (
    <div className="flex gap-4 w-full justify-start">
      <span
        className={`text-xs font-bold border-2 px-2 py-1 rounded-md ${
          isPast
            ? 'text-orange-600 border-orange-300 bg-orange-50'
            : 'text-green-700 border-green-300 bg-green-50'
        }`}
        style={{ fontSize: 13 }}
      >
        {moment(value).format('DD/MM/YYYY')}
      </span>
    </div>
  );
};

export default Dates;
